import React from 'react';
import moment from 'moment';

import './style.scss';
import { resolvePublicAssets } from '../../../../utils';
import { t } from '../../../../locales';
import { CALENDAR_MONTH_UNIT } from '../../../../constants/constants';
import _ from 'lodash';
import { getLanguage } from '../../../../selectors/userSelectors';

const MODES = {
  MONTH: 'month',
};

const DATE_FORMAT = 'YYYYMM';
const lang = getLanguage();
export interface HeaderProps {
  viewDate: Date;
  mode?: 'month';
  onChange: (newViewDate: Date) => void;
  achievedDatesNumber?: string;
  startDate?: Date;
  endDate?: Date;
}

const Header: React.FC<HeaderProps> = ({
  viewDate,
  mode = MODES.MONTH,
  onChange,
  achievedDatesNumber,
  startDate,
  endDate,
}) => {
  const onCtrlBtnClick = (changeSize: number) => {
    if (mode === MODES.MONTH) {
      onChange(moment(viewDate).add(changeSize, 'month').toDate());
    }
  };

  const getMonthTitle = (viewDate: any) => {
    const index = moment(viewDate).month();
    const monthTitle = _.get(CALENDAR_MONTH_UNIT[index], `title.${lang}`, '');
    return monthTitle;
  };

  const isShowStartDateIcon =
    startDate &&
    moment(startDate).format(DATE_FORMAT) <
      moment(viewDate).format(DATE_FORMAT);
  const isShowEndDateIcon =
    endDate &&
    moment(endDate).format(DATE_FORMAT) > moment(viewDate).format(DATE_FORMAT);

  return (
    <div className="calendar-header content-align-right">
      <div
        tabIndex={0}
        className="control-button"
        onClick={() => isShowStartDateIcon && onCtrlBtnClick(-1)}
      >
        {isShowStartDateIcon && (
          <div className="calendar-header-left-icon">
            <img
              src={resolvePublicAssets(
                `assets/images/vhis/arrow-bigger-left.svg`,
              )}
              alt=""
            />
          </div>
        )}
      </div>

      {mode === MODES.MONTH && (
        <div className="calendar-header-content">
          <div className="calendar-header-content-month content-align">
            {getMonthTitle(viewDate)}{' '}
            {moment(viewDate).format('YYYY').toUpperCase()}
          </div>
          {achievedDatesNumber ? (
            <div className="calendar-header-content-achieved-day content-align">
              <span className="calendar-header-content-achieved-day-number">
                {achievedDatesNumber}
              </span>
              {t('AXA_GOAL_RECORD_HEAD_TITLE')}
            </div>
          ) : null}
        </div>
      )}
      <div
        tabIndex={0}
        className="control-button"
        onClick={() => isShowEndDateIcon && onCtrlBtnClick(1)}
      >
        {isShowEndDateIcon && (
          <div className="calendar-header-right-icon">
            <img
              src={resolvePublicAssets(
                `assets/images/vhis/arrow-bigger-right.svg`,
              )}
              alt=""
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
